import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-072d1892"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    type: "text",
    name: _ctx.name,
    class: _normalizeClass(['input', { block: _ctx.block, error: _ctx.error, small: _ctx.small }]),
    value: _ctx.modelValue,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1))
}